export default __webpack_public_path__ + "static/media/onboardingAsideMb.16973ac8.png";